function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import cn from 'classnames';
import { useConversion } from 'hooks';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import messages from 'components/Charts/messages';
import App from 'modules/App';
import * as selectors from 'modules/PatientResults/selectors';
import { getIsPlainValuesMode, getUnitSymbol } from './helpers';
import { useTooltipConfig } from './hooks';
import styles from './GlucoseConcentrationTrend.pcss';
const Tooltip = ({ point, trendData, isInProgress, isTooltipDisabled })=>{
    const calculationFormula = useSelector(selectors.calculationFormula);
    const direction = useSelector(App.selectors.direction);
    const conversion = useConversion('bloodGlucoseConcentration');
    const tooltipConfig = useTooltipConfig();
    if (isTooltipDisabled || isInProgress) {
        return null;
    }
    const { levelTimestamps, flags, manualReadings, originalTimestamps, standardDeviations } = trendData;
    const timestamp = point.data.x;
    const isJoint = levelTimestamps.jointReadings.includes(timestamp);
    if (isJoint) {
        return null;
    }
    const isPlainValuesMode = getIsPlainValuesMode(calculationFormula);
    const value = point.data.y;
    const { dateFormat, timeFormat } = tooltipConfig;
    const unitSymbol = isPlainValuesMode ? getUnitSymbol(calculationFormula) : conversion.unitSymbol;
    const stdDev = standardDeviations[timestamp];
    const isManual = manualReadings.includes(timestamp);
    const stdDevElement = stdDev === undefined ? null : /*#__PURE__*/ _jsx("p", {
        className: "text--large text--primary",
        children: `(${stdDev} ${unitSymbol})`
    });
    const isHigh = levelTimestamps.highReadings.includes(timestamp);
    const isTarget = levelTimestamps.targetReadings.includes(timestamp);
    const isLow = levelTimestamps.lowReadings.includes(timestamp);
    const originalTimestamp = originalTimestamps[timestamp];
    const momentDate = moment.unix(originalTimestamp || timestamp).utc();
    const flag = flags[timestamp] || 'None';
    return /*#__PURE__*/ _jsx("div", {
        className: styles.tooltip,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn('text--large text--bold d-flex align-items-center justify-content-between', {
                        [styles.tooltipHeader__high]: isHigh,
                        [styles.tooltipHeader__target]: isTarget,
                        [styles.tooltipHeader__low]: isLow
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                value,
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "text--small mx-1",
                                    children: [
                                        unitSymbol,
                                        isManual && /*#__PURE__*/ _jsxs("span", {
                                            className: "mx-1",
                                            children: [
                                                "(",
                                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.manual)),
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.tooltip__flagIconContainer,
                            children: /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                                flag: flag
                            })
                        })
                    ]
                }),
                stdDevElement,
                dateFormat || timeFormat ? /*#__PURE__*/ _jsxs("p", {
                    className: "text--light row flex-nowrap justify-content-between",
                    style: {
                        direction
                    },
                    children: [
                        dateFormat && /*#__PURE__*/ _jsx("span", {
                            className: "col-auto",
                            children: momentDate.format(dateFormat)
                        }),
                        timeFormat && /*#__PURE__*/ _jsx("span", {
                            className: `col-auto ${styles.tooltip__time}`,
                            children: momentDate.format(timeFormat)
                        })
                    ]
                }) : null
            ]
        })
    });
};
export default Tooltip;
